import Cookies from 'js-cookie'
import { COOKIE_NAME } from '../constants/constant'

// This cookie holds non-sensitive session metadata only (plain JSON userId,
// tokenExpiry). userRole is intentionally excluded — it is always fetched
// from the backend API on app load to prevent client-side role escalation.
// The actual auth token must NEVER be stored here; it is issued by the backend
// as an HttpOnly, Secure, SameSite=Strict cookie and is inaccessible to JS.
export const setUserCookie = (data) => {
  Cookies.set(COOKIE_NAME, JSON.stringify(data), {
    expires: 7, // days
    secure: true,
    sameSite: 'Strict',
  })
}

export const getUserCookie = () => {
  const raw = Cookies.get(COOKIE_NAME)
  if (!raw) return null

  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export const removeUserCookie = () => {
  Cookies.remove(COOKIE_NAME)
}
